import React, { useEffect, useState, memo, createElement } from 'react';
import { ShieldCheck, Download, BookOpen, Clock, Map, FileText, CheckCircle, ArrowRight, Star, ChevronLeft, ChevronRight } from 'lucide-react';
import { PurchaseNotification } from './components/PurchaseNotification';
import { PricingCard } from './components/PricingCard';
import { TestimonialCard } from './components/TestimonialCard';
import { FAQItem } from './components/FAQItem';
import { ImageCarousel } from './components/ImageCarousel';
// Images
const MAIN_PRODUCT_IMG = 'https://cdn.magicpatterns.com/uploads/8sNjZ2Ea2LKzmnxA3LTx4m/Cover_SIC_360_(2).png';
const BONUS_1_IMG = 'https://cdn.magicpatterns.com/uploads/7DSGHwe5XwQy447F5akiJn/Captura_de_pantalla_2026-01-14_a_la(s)_10.40.48_p._m..png';
const BONUS_2_IMG = 'https://cdn.magicpatterns.com/uploads/45ET6rVjJKcXvdVnoDp45k/Captura_de_pantalla_2026-01-14_a_la(s)_10.40.54_p._m..png';
const BONUS_3_IMG = 'https://cdn.magicpatterns.com/uploads/8Z8PZwwvU8nhXHAN7mxAnX/Captura_de_pantalla_2026-01-14_a_la(s)_10.40.59_p._m..png';
const BONUS_4_IMG = 'https://cdn.magicpatterns.com/uploads/43EC9tcnbnTpGP8efMRTrt/Captura_de_pantalla_2026-01-14_a_la(s)_10.41.12_p._m..png';
export function App() {
  // Meta Pixel Integration
  useEffect(() => {
    // @ts-ignore
    if (typeof window !== 'undefined' && !window.fbq) {
      // @ts-ignore
      window.fbq = function () {
        // @ts-ignore
        window.fbq.callMethod ? window.fbq.callMethod.apply(window.fbq, arguments) : window.fbq.queue.push(arguments);
      };
      // @ts-ignore
      if (!window._fbq) window._fbq = window.fbq;
      // @ts-ignore
      window.fbq.push = window.fbq;
      // @ts-ignore
      window.fbq.loaded = true;
      // @ts-ignore
      window.fbq.version = '2.0';
      // @ts-ignore
      window.fbq.queue = [];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
      // @ts-ignore
      window.fbq('init', '1431047751745405');
      // @ts-ignore
      window.fbq('track', 'PageView');
    }
  }, []);
  const scrollToPurchase = () => {
    const element = document.getElementById('purchase');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="min-h-screen bg-white font-sans text-gray-900" data-id="element-0">
      <PurchaseNotification data-id="element-1" />

      {/* Hero Section */}
      <header className="relative overflow-hidden bg-gradient-to-b from-blue-900 to-blue-800 text-white pb-16 pt-12 md:pb-24 md:pt-20" data-id="element-2">
        <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-10" data-id="element-3"></div>
        <div className="container mx-auto px-4 relative z-10" data-id="element-4">
          <div className="flex flex-col items-center text-center max-w-4xl mx-auto" data-id="element-5">
            <span className="mb-4 inline-block rounded-full bg-orange-500 px-4 py-1.5 text-sm font-bold uppercase tracking-wider text-white shadow-lg" data-id="element-6">
              Para docentes de nivel secundario
            </span>
            <h1 className="mb-6 text-4xl font-extrabold leading-tight tracking-tight md:text-6xl lg:text-7xl" data-id="element-7">
              SIC <span className="text-orange-400" data-id="element-8">360</span>
            </h1>
            <p className="mb-8 text-xl font-medium text-blue-100 md:text-2xl max-w-2xl" data-id="element-9">
              Todo el año de Contabilidad resuelto para enseñar con claridad,
              seguridad y sentido real sin planificar nada desde cero.
            </p>

            <div className="mb-10 w-full max-w-lg transform transition-transform hover:scale-105 duration-500" data-id="element-10">
              <img src={MAIN_PRODUCT_IMG} alt="SIC 360 Sistema de Información Contable" className="mx-auto w-full drop-shadow-2xl rounded-lg" data-id="element-11" />
            </div>

            <button onClick={scrollToPurchase} className="group relative inline-flex items-center justify-center overflow-hidden rounded-full bg-orange-500 px-8 py-4 text-lg font-bold text-white shadow-xl transition-all hover:bg-orange-600 hover:scale-105 focus:outline-none focus:ring-4 focus:ring-orange-300" data-id="element-12">
              DESCUBRIR SIC 360
              <ArrowRight className="ml-2 h-5 w-5 transition-transform group-hover:translate-x-1" data-id="element-13" />
            </button>
          </div>
        </div>
      </header>

      {/* Problem Section */}
      <section className="py-16 md:py-24 bg-gray-50" data-id="element-14">
        <div className="container mx-auto px-4 max-w-3xl" data-id="element-15">
          <div className="prose prose-lg mx-auto text-gray-700" data-id="element-16">
            <p className="lead text-xl md:text-2xl font-medium text-gray-900 mb-8" data-id="element-17">
              Si alguna vez entraste al aula sabiendo que tenías que explicar
              Sistemas de Información Contable… pero sin estar del todo seguro
              de cómo hacerlo claro, esto es para vos.
            </p>

            <p data-id="element-18">
              No porque no sepas contabilidad. No porque no tengas formación. No
              porque no te importe enseñar bien.
            </p>
            <p className="font-bold text-blue-900 text-xl" data-id="element-19">
              Sino porque nadie te dio una herramienta pensada para tu realidad
              docente.
            </p>

            <div className="my-12 bg-white p-8 rounded-xl shadow-sm border-l-4 border-red-500" data-id="element-20">
              <h3 className="text-2xl font-bold text-gray-900 mt-0" data-id="element-21">
                El problema no es la contabilidad
              </h3>
              <p className="text-lg" data-id="element-22">
                El problema es cómo nos obligaron a enseñarla.
              </p>
            </div>

            <p data-id="element-23">
              La contabilidad está en todos lados. En el precio del colectivo.
              En el sueldo que no alcanza. En la inflación que aparece en las
              noticias. En las decisiones que toman las familias todos los días.
            </p>

            <p className="font-semibold mt-6" data-id="element-24">
              Y sin embargo… En el aula pasa esto:
            </p>
            <ul className="space-y-2 mt-4 list-none pl-0" data-id="element-25">
              <li className="flex items-center gap-3 text-gray-600" data-id="element-26">
                <span className="text-red-500 text-xl" data-id="element-27">✕</span> Alumnos
                desconectados
              </li>
              <li className="flex items-center gap-3 text-gray-600" data-id="element-28">
                <span className="text-red-500 text-xl" data-id="element-29">✕</span> Miradas perdidas
              </li>
              <li className="flex items-center gap-3 text-gray-600" data-id="element-30">
                <span className="text-red-500 text-xl" data-id="element-31">✕</span> Celulares bajo
                el banco
              </li>
            </ul>

            <p className="mt-8 italic text-lg border-l-4 border-gray-300 pl-4" data-id="element-32">
              La pregunta inevitable: "Profe… ¿esto para qué sirve?"
            </p>

            <p className="mt-6" data-id="element-33">
              Y ahí aparece la frustración. Porque vos sabés que la materia es
              importante. Porque querés que entiendan. Porque te esforzás. Pero
              algo no baja.
            </p>
          </div>

          <div className="mt-12 text-center" data-id="element-34">
            <button onClick={scrollToPurchase} className="inline-flex items-center justify-center rounded-lg bg-blue-900 px-6 py-3 text-base font-bold text-white shadow-lg transition-all hover:bg-blue-800 hover:-translate-y-1" data-id="element-35">
              QUIERO CAMBIAR ESTO
            </button>
          </div>
        </div>
      </section>

      {/* Solution Section */}
      <section className="py-16 md:py-24 bg-white" data-id="element-36">
        <div className="container mx-auto px-4 max-w-4xl" data-id="element-37">
          <div className="text-center mb-16" data-id="element-38">
            <h2 className="text-3xl md:text-5xl font-extrabold text-blue-900 mb-6" data-id="element-39">
              Lo que nadie dice en voz alta
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-40">
              El problema no sos vos. El problema es que Sistemas de Información
              Contable se enseña como si el alumno ya entendiera el sistema.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-12 items-center mb-16" data-id="element-41">
            <div className="bg-red-50 p-8 rounded-2xl border border-red-100" data-id="element-42">
              <h3 className="text-xl font-bold text-red-800 mb-4" data-id="element-43">
                ❌ La forma tradicional
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-44">
                Se empieza por definiciones. Por conceptos aislados. Por teoría.
              </p>
              <div className="space-y-2 opacity-70" data-id="element-45">
                <div className="h-2 bg-red-200 rounded w-3/4" data-id="element-46"></div>
                <div className="h-2 bg-red-200 rounded w-full" data-id="element-47"></div>
                <div className="h-2 bg-red-200 rounded w-5/6" data-id="element-48"></div>
              </div>
            </div>

            <div className="bg-green-50 p-8 rounded-2xl border border-green-100 shadow-lg transform md:scale-105" data-id="element-49">
              <h3 className="text-xl font-bold text-green-800 mb-4" data-id="element-50">
                ✅ La propuesta SIC 360
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-51">Se empieza por:</p>
              <ul className="space-y-3" data-id="element-52">
                <li className="flex items-center gap-2 font-bold text-gray-800" data-id="element-53">
                  <CheckCircle className="w-5 h-5 text-green-600" data-id="element-54" /> La función
                </li>
                <li className="flex items-center gap-2 font-bold text-gray-800" data-id="element-55">
                  <CheckCircle className="w-5 h-5 text-green-600" data-id="element-56" /> La lógica
                </li>
                <li className="flex items-center gap-2 font-bold text-gray-800" data-id="element-57">
                  <CheckCircle className="w-5 h-5 text-green-600" data-id="element-58" /> El para qué
                </li>
              </ul>
            </div>
          </div>

          <div className="bg-blue-900 text-white rounded-3xl p-8 md:p-12 text-center shadow-2xl relative overflow-hidden" data-id="element-59">
            <div className="relative z-10" data-id="element-60">
              <span className="inline-block bg-orange-500 text-white text-xs font-bold px-3 py-1 rounded-full mb-4 uppercase tracking-wide" data-id="element-61">
                La Solución
              </span>
              <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-62">
                Y ahí aparece SIC 360
              </h2>
              <p className="text-lg md:text-xl text-blue-100 mb-8 max-w-2xl mx-auto" data-id="element-63">
                SIC 360 no es un libro. No es un PDF más. No es un PowerPoint
                genérico. Es un sistema de clases listas, pensado
                específicamente para docentes de secundaria.
              </p>

              <div className="flex flex-col md:flex-row justify-center items-center gap-4 md:gap-8 text-lg font-bold bg-blue-800/50 p-6 rounded-xl inline-flex" data-id="element-64">
                <span data-id="element-65">PARA QUÉ</span>
                <ArrowRight className="hidden md:block text-orange-400" data-id="element-66" />
                <span className="md:hidden text-orange-400" data-id="element-67">↓</span>
                <span data-id="element-68">CÓMO</span>
                <ArrowRight className="hidden md:block text-orange-400" data-id="element-69" />
                <span className="md:hidden text-orange-400" data-id="element-70">↓</span>
                <span data-id="element-71">QUÉ</span>
              </div>

              <p className="mt-8 font-medium text-orange-300" data-id="element-72">
                De lo concreto a lo conceptual. De la lógica del sistema a la
                técnica.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-16 bg-gray-50" data-id="element-73">
        <div className="container mx-auto px-4" data-id="element-74">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12" data-id="element-75">
            ¿Qué cambia cuando enseñás con SIC 360?
          </h2>

          <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-76">
            <div className="bg-white p-8 rounded-xl shadow-md hover:shadow-xl transition-shadow border-t-4 border-blue-500" data-id="element-77">
              <div className="bg-blue-100 w-12 h-12 rounded-full flex items-center justify-center mb-6" data-id="element-78">
                <Map className="w-6 h-6 text-blue-600" data-id="element-79" />
              </div>
              <h3 className="text-xl font-bold mb-4" data-id="element-80">Un GPS educativo</h3>
              <p className="text-gray-600" data-id="element-81">
                Sabés el recorrido. No improvisás. Entrás al aula con la clase
                ya resuelta. Sabés exactamente qué explicar, cómo y en qué
                orden.
              </p>
            </div>

            <div className="bg-white p-8 rounded-xl shadow-md hover:shadow-xl transition-shadow border-t-4 border-orange-500" data-id="element-82">
              <div className="bg-orange-100 w-12 h-12 rounded-full flex items-center justify-center mb-6" data-id="element-83">
                <ShieldCheck className="w-6 h-6 text-orange-600" data-id="element-84" />
              </div>
              <h3 className="text-xl font-bold mb-4" data-id="element-85">Un plano de una casa</h3>
              <p className="text-gray-600" data-id="element-86">
                Primero cimientos. Después estructura. Los alumnos entienden,
                participan y conectan porque ven la construcción lógica.
              </p>
            </div>

            <div className="bg-white p-8 rounded-xl shadow-md hover:shadow-xl transition-shadow border-t-4 border-green-500" data-id="element-87">
              <div className="bg-green-100 w-12 h-12 rounded-full flex items-center justify-center mb-6" data-id="element-88">
                <FileText className="w-6 h-6 text-green-600" data-id="element-89" />
              </div>
              <h3 className="text-xl font-bold mb-4" data-id="element-90">Un manual de piloto</h3>
              <p className="text-gray-600" data-id="element-91">
                Podés volar igual… pero con esto todo es más seguro. Enseñás con
                seguridad, dejás de improvisar y volvés a disfrutar enseñar.
              </p>
            </div>
          </div>

          <div className="mt-16 text-center max-w-3xl mx-auto" data-id="element-92">
            <p className="text-lg text-gray-700 mb-8" data-id="element-93">
              SIC 360 nació de una frustración real. De ver docentes preparados,
              con vocación, agotados. La pregunta fue simple:{' '}
              <strong data-id="element-94">
                ¿Y si el problema no es el docente… sino el material?
              </strong>
            </p>
            <button onClick={scrollToPurchase} className="inline-flex items-center justify-center rounded-full bg-orange-500 px-8 py-4 text-lg font-bold text-white shadow-lg transition-all hover:bg-orange-600 hover:scale-105" data-id="element-95">
              QUIERO ENSEÑAR SIN ESTRÉS
            </button>
          </div>
        </div>
      </section>

      {/* Bonuses Section */}
      <section className="py-16 md:py-24 bg-blue-900 text-white overflow-hidden" data-id="element-96">
        <div className="container mx-auto px-4" data-id="element-97">
          <div className="text-center mb-16" data-id="element-98">
            <span className="inline-block bg-yellow-400 text-blue-900 text-sm font-bold px-4 py-1 rounded-full mb-4 uppercase tracking-wide animate-pulse" data-id="element-99">
              GRATIS POR HOY
            </span>
            <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-100">
              Llevate estos 4 Bonos Exclusivos
            </h2>
            <p className="text-xl text-blue-200 max-w-2xl mx-auto" data-id="element-101">
              Herramientas complementarias para blindar tu año escolar.
              Incluidos sin cargo con tu compra.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-102">
            {[{
            img: BONUS_1_IMG,
            title: 'BONO 1: Clases Salvavidas',
            desc: 'Plan B Docente para cuando falta tiempo o surge un imprevisto.'
          }, {
            img: BONUS_2_IMG,
            title: 'BONO 2: Evaluaciones Listas',
            desc: 'Pruebas escritas, trabajos prácticos y rúbricas claras.'
          }, {
            img: BONUS_3_IMG,
            title: 'BONO 3: Mapa Anual',
            desc: 'Un año completo en una sola hoja. Qué dar y en qué orden.'
          }, {
            img: BONUS_4_IMG,
            title: 'BONO 4: Banco de Ejemplos',
            desc: 'Asientos contables explicados paso a paso para decir en voz alta.'
          }].map((bonus, idx) => <div key={idx} className="group" data-id="element-103">
                <div className="mb-6 overflow-hidden rounded-xl shadow-2xl transition-transform duration-300 group-hover:scale-105" data-id="element-104">
                  <img src={bonus.img} alt={bonus.title} className="w-full h-auto" data-id="element-105" />
                </div>
                <h3 className="text-xl font-bold text-yellow-400 mb-2" data-id="element-106">
                  {bonus.title}
                </h3>
                <p className="text-blue-100 text-sm" data-id="element-107">{bonus.desc}</p>
              </div>)}
          </div>

          <div className="mt-16 text-center" data-id="element-108">
            <button onClick={scrollToPurchase} className="inline-flex items-center justify-center rounded-lg bg-white px-8 py-4 text-lg font-bold text-blue-900 shadow-xl transition-all hover:bg-gray-100 hover:scale-105" data-id="element-109">
              QUIERO LOS BONOS GRATIS
            </button>
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section id="purchase" className="py-16 md:py-24 bg-gray-50" data-id="element-110">
        <div className="container mx-auto px-4" data-id="element-111">
          <div className="text-center mb-16" data-id="element-112">
            <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-4" data-id="element-113">
              Elegí tu Pack
            </h2>
            <p className="text-xl text-gray-600" data-id="element-114">
              Acceso inmediato y vitalicio a todo el material
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto items-end" data-id="element-115">
            {/* Tier 1 - Custom Design */}
            <div className="flex flex-col rounded-3xl border-4 border-orange-500 bg-white p-8 shadow-2xl" data-id="element-116">
              {/* Product Image */}
              <div className="mb-6 -mt-4" data-id="element-117">
                <img src="https://cdn.magicpatterns.com/uploads/8sNjZ2Ea2LKzmnxA3LTx4m/Cover_SIC_360_(2).png" alt="SIC 360" className="w-full h-auto rounded-lg" data-id="element-118" />
              </div>

              {/* Pricing */}
              <div className="mb-8 text-center" data-id="element-119">
                <p className="text-sm font-bold text-gray-400 uppercase tracking-wider mb-2" data-id="element-120">
                  PRECIO FINAL
                </p>
                <div className="mb-2" data-id="element-121">
                  <div className="text-2xl font-bold text-red-500 line-through mb-1" data-id="element-122">
                    $49.99 USD
                  </div>
                  <div className="text-5xl font-extrabold text-blue-900" data-id="element-123">
                    $12.99
                  </div>
                  <div className="text-lg font-medium text-gray-600 mt-1" data-id="element-124">
                    USD
                  </div>
                </div>
                <p className="text-xs text-gray-500 italic" data-id="element-125">
                  Pagarás en la moneda de tu país
                </p>
              </div>

              {/* Features */}
              <div className="space-y-4 mb-8" data-id="element-126">
                <div className="bg-green-50 border border-green-100 rounded-xl p-4" data-id="element-127">
                  <div className="flex items-start gap-3" data-id="element-128">
                    <div className="flex-shrink-0 w-6 h-6 bg-green-500 rounded-full flex items-center justify-center" data-id="element-129">
                      <CheckCircle className="w-4 h-4 text-white" data-id="element-130" />
                    </div>
                    <div data-id="element-131">
                      <h4 className="font-bold text-gray-900 mb-1" data-id="element-132">
                        Sistema Completo SIC 360
                      </h4>
                      <p className="text-sm text-gray-600" data-id="element-133">
                        Clases estructuradas para todo el año lectivo con
                        ejemplos argentinos actuales
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-orange-50 border border-orange-100 rounded-xl p-4" data-id="element-134">
                  <div className="flex items-start gap-3" data-id="element-135">
                    <div className="flex-shrink-0 w-6 h-6 bg-green-500 rounded-full flex items-center justify-center" data-id="element-136">
                      <CheckCircle className="w-4 h-4 text-white" data-id="element-137" />
                    </div>
                    <div data-id="element-138">
                      <h4 className="font-bold text-gray-900 mb-1" data-id="element-139">
                        4 Bonos Exclusivos (Gratis por hoy)
                      </h4>
                      <p className="text-sm text-gray-600" data-id="element-140">
                        Banco de ejemplos, clases express, evaluaciones listas y
                        mapa anual de contenidos
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-blue-50 border border-blue-100 rounded-xl p-4" data-id="element-141">
                  <div className="flex items-start gap-3" data-id="element-142">
                    <div className="flex-shrink-0 w-6 h-6 bg-green-500 rounded-full flex items-center justify-center" data-id="element-143">
                      <CheckCircle className="w-4 h-4 text-white" data-id="element-144" />
                    </div>
                    <div data-id="element-145">
                      <h4 className="font-bold text-gray-900 mb-1" data-id="element-146">
                        Acceso Inmediato y Vitalicio
                      </h4>
                      <p className="text-sm text-gray-600" data-id="element-147">
                        Descargá todo el material al instante y accedé cuando lo
                        necesites, sin vencimiento
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* CTA Button */}
              <a href="https://checkout12.edulabs.online/cart/52914635538797:1" target="_blank" rel="noopener noreferrer" className="group w-full rounded-xl bg-orange-500 px-6 py-4 text-center text-base font-bold uppercase tracking-wider text-white shadow-lg transition-all hover:bg-orange-600 hover:scale-105 flex items-center justify-center gap-2" data-id="element-148">
                ACCEDÉ AHORA Y EMPEZÁ A ENSEÑAR
                <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-1" data-id="element-149" />
              </a>

              {/* Trust Badges */}
              <div className="mt-6 flex items-center justify-center gap-6 text-xs text-gray-500" data-id="element-150">
                <div className="flex items-center gap-1" data-id="element-151">
                  <ShieldCheck className="w-4 h-4" data-id="element-152" />
                  <span data-id="element-153">Compra Segura</span>
                </div>
                <div className="flex items-center gap-1" data-id="element-154">
                  <Download className="w-4 h-4" data-id="element-155" />
                  <span data-id="element-156">Material Digital</span>
                </div>
              </div>
            </div>

            {/* Tier 2 - Pack Full with Carousel */}
            <div className="flex flex-col rounded-3xl border-4 border-yellow-500 bg-white p-8 shadow-2xl relative" data-id="element-157">
              {/* Popular Badge */}
              <div className="absolute -top-4 right-4 rounded-full bg-blue-600 px-4 py-1.5 text-xs font-bold text-white uppercase tracking-wide shadow-lg" data-id="element-158">
                ⭐ Más Popular
              </div>

              {/* Image Carousel */}
              <ImageCarousel images={['https://cdn.magicpatterns.com/uploads/hYTca8v5Kh4rfcuz33dFgE/Cover_SIC_360_(3).png', 'https://cdn.magicpatterns.com/uploads/9AobyEnp9pjcowtwie6hti/conver_micro_y_macro_(3).png', 'https://cdn.magicpatterns.com/uploads/f48CUCdSbP9WjCocGntbwG/ChatGPT_Image_11_ene_2026,_07_34_47_p.m._(3).png']} data-id="element-159" />

              {/* Pricing */}
              <div className="mb-8 text-center" data-id="element-160">
                <p className="text-sm font-bold text-gray-400 uppercase tracking-wider mb-2" data-id="element-161">
                  PRECIO PACK COMPLETO
                </p>
                <div className="mb-2" data-id="element-162">
                  <div className="text-2xl font-bold text-red-500 line-through mb-1" data-id="element-163">
                    $57.99 USD
                  </div>
                  <div className="text-5xl font-extrabold text-blue-900" data-id="element-164">
                    $27.99
                  </div>
                  <div className="text-lg font-medium text-gray-600 mt-1" data-id="element-165">
                    USD
                  </div>
                </div>
                <div className="inline-block bg-green-100 px-3 py-1 rounded-md mb-2" data-id="element-166">
                  <p className="text-sm font-bold text-green-700" data-id="element-167">
                    Ahorrás $30 USD con el pack completo
                  </p>
                </div>
                <p className="text-xs text-gray-500 italic" data-id="element-168">
                  Pagarás en la moneda de tu país
                </p>
              </div>

              {/* Features */}
              <div className="space-y-4 mb-8" data-id="element-169">
                <div className="bg-green-50 border border-green-100 rounded-xl p-4" data-id="element-170">
                  <div className="flex items-start gap-3" data-id="element-171">
                    <div className="flex-shrink-0 w-6 h-6 bg-green-500 rounded-full flex items-center justify-center" data-id="element-172">
                      <CheckCircle className="w-4 h-4 text-white" data-id="element-173" />
                    </div>
                    <div data-id="element-174">
                      <h4 className="font-bold text-gray-900 mb-1" data-id="element-175">
                        Sistema Completo SIC 360
                      </h4>
                      <p className="text-sm text-gray-600" data-id="element-176">
                        Clases estructuradas para todo el año lectivo con
                        ejemplos argentinos actuales
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-orange-50 border border-orange-100 rounded-xl p-4" data-id="element-177">
                  <div className="flex items-start gap-3" data-id="element-178">
                    <div className="flex-shrink-0 w-6 h-6 bg-green-500 rounded-full flex items-center justify-center" data-id="element-179">
                      <CheckCircle className="w-4 h-4 text-white" data-id="element-180" />
                    </div>
                    <div data-id="element-181">
                      <h4 className="font-bold text-gray-900 mb-1" data-id="element-182">
                        4 Bonos Exclusivos (Gratis por hoy)
                      </h4>
                      <p className="text-sm text-gray-600" data-id="element-183">
                        Banco de ejemplos, clases express, evaluaciones listas y
                        mapa anual de contenidos
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-blue-50 border border-blue-100 rounded-xl p-4" data-id="element-184">
                  <div className="flex items-start gap-3" data-id="element-185">
                    <div className="flex-shrink-0 w-6 h-6 bg-green-500 rounded-full flex items-center justify-center" data-id="element-186">
                      <CheckCircle className="w-4 h-4 text-white" data-id="element-187" />
                    </div>
                    <div data-id="element-188">
                      <h4 className="font-bold text-gray-900 mb-1" data-id="element-189">
                        Acceso Inmediato y Vitalicio
                      </h4>
                      <p className="text-sm text-gray-600" data-id="element-190">
                        Descargá todo el material al instante y accedé cuando lo
                        necesites, sin vencimiento
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-yellow-50 border-2 border-yellow-400 rounded-xl p-4 relative" data-id="element-191">
                  <div className="absolute -top-3 right-4 bg-yellow-500 text-blue-900 text-xs font-bold px-2 py-1 rounded" data-id="element-192">
                    EXTRA
                  </div>
                  <div className="flex items-start gap-3" data-id="element-193">
                    <div className="flex-shrink-0 w-6 h-6 bg-yellow-500 rounded-full flex items-center justify-center" data-id="element-194">
                      <CheckCircle className="w-4 h-4 text-white" data-id="element-195" />
                    </div>
                    <div data-id="element-196">
                      <h4 className="font-bold text-gray-900 mb-1" data-id="element-197">
                        MICRO Y MACRO ECONOMÍA 360 + 100 MICRO-EMPRENDIMIENTOS
                        GANADORES
                      </h4>
                      <p className="text-sm text-gray-600" data-id="element-198">
                        El pack completo de micro y macro economía 360 + 100
                        ideas reales de emprendimientos para trabajar con
                        alumnos de último año
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* CTA Button */}
              <a href="https://checkout12.edulabs.online/cart/52914645565805:1" target="_blank" rel="noopener noreferrer" className="group w-full rounded-xl bg-gradient-to-r from-orange-500 to-orange-600 px-6 py-4 text-center text-base font-bold uppercase tracking-wider text-white shadow-lg transition-all hover:from-orange-600 hover:to-orange-700 hover:scale-105 flex items-center justify-center gap-2" data-id="element-199">
                ACCEDÉ AL PACK FULL
                <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-1" data-id="element-200" />
              </a>

              {/* Trust Badges */}
              <div className="mt-6 flex items-center justify-center gap-6 text-xs text-gray-500" data-id="element-201">
                <div className="flex items-center gap-1" data-id="element-202">
                  <ShieldCheck className="w-4 h-4" data-id="element-203" />
                  <span data-id="element-204">Compra Segura</span>
                </div>
                <div className="flex items-center gap-1" data-id="element-205">
                  <Download className="w-4 h-4" data-id="element-206" />
                  <span data-id="element-207">Material Digital</span>
                </div>
              </div>
            </div>

            {/* Tier 3 - Megapack with Carousel */}
            <div className="flex flex-col rounded-3xl border-4 border-purple-500 bg-white p-8 shadow-2xl relative" data-id="element-208">
              {/* Best Seller Badge */}
              <div className="absolute -top-4 right-4 rounded-full bg-green-600 px-4 py-1.5 text-xs font-bold text-white uppercase tracking-wide shadow-lg" data-id="element-209">
                🔥 Más Vendido
              </div>

              {/* Image Carousel */}
              <ImageCarousel images={['https://cdn.magicpatterns.com/uploads/42CKAj75xi5ThDBR5wkba9/COVER_NTICX360_(2).png', 'https://cdn.magicpatterns.com/uploads/cBoSB5a5AhEA992ZuuWB88/Cover_SIC_360_(4).png', 'https://cdn.magicpatterns.com/uploads/nMq3T6TJx4YCp4Aq6HKmAu/conver_micro_y_macro_(4).png']} data-id="element-210" />

              {/* Pricing */}
              <div className="mb-8 text-center" data-id="element-211">
                <p className="text-sm font-bold text-gray-400 uppercase tracking-wider mb-2" data-id="element-212">
                  PRECIO MEGAPACK COMPLETO
                </p>
                <div className="mb-2" data-id="element-213">
                  <div className="text-2xl font-bold text-red-500 line-through mb-1" data-id="element-214">
                    $87.99 USD
                  </div>
                  <div className="text-5xl font-extrabold text-purple-700" data-id="element-215">
                    $33.99
                  </div>
                  <div className="text-lg font-medium text-gray-600 mt-1" data-id="element-216">
                    USD
                  </div>
                </div>
                <div className="inline-block bg-green-100 px-3 py-1 rounded-md mb-2" data-id="element-217">
                  <p className="text-sm font-bold text-green-700" data-id="element-218">
                    Ahorrás $54 USD con el megapack completo
                  </p>
                </div>
                <p className="text-xs text-gray-500 italic" data-id="element-219">
                  Pagarás en la moneda de tu país
                </p>
              </div>

              {/* Features */}
              <div className="space-y-4 mb-8" data-id="element-220">
                <div className="bg-green-50 border border-green-100 rounded-xl p-4" data-id="element-221">
                  <div className="flex items-start gap-3" data-id="element-222">
                    <div className="flex-shrink-0 w-6 h-6 bg-green-500 rounded-full flex items-center justify-center" data-id="element-223">
                      <CheckCircle className="w-4 h-4 text-white" data-id="element-224" />
                    </div>
                    <div data-id="element-225">
                      <h4 className="font-bold text-gray-900 mb-1" data-id="element-226">
                        Sistema Completo SIC 360
                      </h4>
                      <p className="text-sm text-gray-600" data-id="element-227">
                        Clases estructuradas para todo el año lectivo con
                        ejemplos argentinos actuales
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-orange-50 border border-orange-100 rounded-xl p-4" data-id="element-228">
                  <div className="flex items-start gap-3" data-id="element-229">
                    <div className="flex-shrink-0 w-6 h-6 bg-green-500 rounded-full flex items-center justify-center" data-id="element-230">
                      <CheckCircle className="w-4 h-4 text-white" data-id="element-231" />
                    </div>
                    <div data-id="element-232">
                      <h4 className="font-bold text-gray-900 mb-1" data-id="element-233">
                        4 Bonos Exclusivos (Gratis por hoy)
                      </h4>
                      <p className="text-sm text-gray-600" data-id="element-234">
                        Banco de ejemplos, clases express, evaluaciones listas y
                        mapa anual de contenidos
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-blue-50 border border-blue-100 rounded-xl p-4" data-id="element-235">
                  <div className="flex items-start gap-3" data-id="element-236">
                    <div className="flex-shrink-0 w-6 h-6 bg-green-500 rounded-full flex items-center justify-center" data-id="element-237">
                      <CheckCircle className="w-4 h-4 text-white" data-id="element-238" />
                    </div>
                    <div data-id="element-239">
                      <h4 className="font-bold text-gray-900 mb-1" data-id="element-240">
                        Acceso Inmediato y Vitalicio
                      </h4>
                      <p className="text-sm text-gray-600" data-id="element-241">
                        Descargá todo el material al instante y accedé cuando lo
                        necesites, sin vencimiento
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-purple-50 border-2 border-purple-400 rounded-xl p-4 relative" data-id="element-242">
                  <div className="absolute -top-3 right-4 bg-purple-600 text-white text-xs font-bold px-2 py-1 rounded" data-id="element-243">
                    EXTRA
                  </div>
                  <div className="flex items-start gap-3" data-id="element-244">
                    <div className="flex-shrink-0 w-6 h-6 bg-purple-600 rounded-full flex items-center justify-center" data-id="element-245">
                      <CheckCircle className="w-4 h-4 text-white" data-id="element-246" />
                    </div>
                    <div data-id="element-247">
                      <h4 className="font-bold text-gray-900 mb-1" data-id="element-248">
                        NTICX 360 + SIC 360 + MICRO Y MACRO ECONOMÍA 360
                      </h4>
                      <p className="text-sm text-gray-600" data-id="element-249">
                        Megapack comercial contable con clases resueltas para
                        todo el año
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* CTA Button */}
              <a href="https://checkout12.edulabs.online/cart/52914690589037:1" target="_blank" rel="noopener noreferrer" className="group w-full rounded-xl bg-gradient-to-r from-purple-600 to-purple-700 px-6 py-4 text-center text-base font-bold uppercase tracking-wider text-white shadow-lg transition-all hover:from-purple-700 hover:to-purple-800 hover:scale-105 flex items-center justify-center gap-2" data-id="element-250">
                ACCEDÉ AL MEGAPACK COMERCIAL CONTABLE 360
                <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-1" data-id="element-251" />
              </a>

              {/* Trust Badges */}
              <div className="mt-6 flex items-center justify-center gap-6 text-xs text-gray-500" data-id="element-252">
                <div className="flex items-center gap-1" data-id="element-253">
                  <ShieldCheck className="w-4 h-4" data-id="element-254" />
                  <span data-id="element-255">Compra Segura</span>
                </div>
                <div className="flex items-center gap-1" data-id="element-256">
                  <Download className="w-4 h-4" data-id="element-257" />
                  <span data-id="element-258">Material Digital</span>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-12 flex flex-col md:flex-row justify-center items-center gap-6 text-gray-500 text-sm" data-id="element-259">
            <div className="flex items-center gap-2" data-id="element-260">
              <ShieldCheck className="w-5 h-5 text-green-500" data-id="element-261" /> Compra Segura
            </div>
            <div className="flex items-center gap-2" data-id="element-262">
              <Download className="w-5 h-5 text-blue-500" data-id="element-263" /> Material 100%
              Digital
            </div>
            <div className="flex items-center gap-2" data-id="element-264">
              <Clock className="w-5 h-5 text-orange-500" data-id="element-265" /> Acceso Inmediato
            </div>
          </div>
        </div>
      </section>

      {/* Guarantee Section */}
      <section className="py-16 bg-white border-y border-gray-100" data-id="element-266">
        <div className="container mx-auto px-4 max-w-4xl" data-id="element-267">
          <div className="flex flex-col md:flex-row items-center gap-8 bg-gray-50 p-8 rounded-2xl border border-gray-200" data-id="element-268">
            <div className="flex-shrink-0" data-id="element-269">
              <div className="w-24 h-24 bg-yellow-400 rounded-full flex items-center justify-center shadow-lg" data-id="element-270">
                <ShieldCheck className="w-12 h-12 text-blue-900" data-id="element-271" />
              </div>
            </div>
            <div data-id="element-272">
              <h3 className="text-2xl font-bold text-gray-900 mb-3" data-id="element-273">
                Garantía sin vueltas
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-274">
                Estamos tan seguros de que este Programa te va a encantar, que
                si no es así, te devolvemos el 100% de tu dinero.
              </p>
              <p className="text-gray-700 font-medium" data-id="element-275">
                Tenés 7 días para probarlo sin riesgo. Si no te convence, nos
                escribís y te hacemos el reembolso. Así de simple.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="py-16 md:py-24 bg-blue-50" data-id="element-276">
        <div className="container mx-auto px-4" data-id="element-277">
          <div className="text-center mb-16" data-id="element-278">
            <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6" data-id="element-279">
              Lo que dicen otros docentes
            </h2>
            <p className="text-xl text-gray-600" data-id="element-280">
              Colegas de todo el país que ya están transformando sus clases con
              SIC 360.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto" data-id="element-281">
            <TestimonialCard name="María González" role="Docente de SIC y Economía" location="Madrid, España" age={42} content="Hace 15 años que doy clases y siempre sentía que los chicos memorizaban sin entender. Con SIC 360 logré que por fin conecten los conceptos. Las clases ya están armadas, lo que me ahorra horas de planificación los fines de semana." imageInitials="MG" data-id="element-282" />
            <TestimonialCard name="Carlos Ramírez" role="Profesor de Contabilidad" location="Ciudad de México, México" age={38} content="Lo que más valoro es el orden. Antes picoteaba de libros viejos y PDFs de internet. Ahora tengo un camino claro. Mis alumnos de preparatoria cambiaron totalmente la actitud, participan más porque entienden la lógica desde el principio." imageInitials="CR" data-id="element-283" />
            <TestimonialCard name="Laura Martínez" role="Docente Nivel Secundario" location="Bogotá, Colombia" age={29} content="Empecé a dar clases hace poco y me sentía muy insegura improvisando. Este material fue mi salvación. Es como tener un mentor que te dice exactamente cómo explicar cada tema para que los adolescentes te presten atención." imageInitials="LM" data-id="element-284" />
            <TestimonialCard name="José Luis Torres" role="Profesor de Gestión" location="Lima, Perú" age={51} content="Pensé que a mi edad ya no iba a cambiar mi forma de dar clase, pero me animé a probar. Es increíble cómo cambia la dinámica cuando explicás el 'por qué' antes del 'cómo'. Una herramienta indispensable para el aula de hoy." imageInitials="JT" data-id="element-285" />
            <TestimonialCard name="Ana Sofía Vargas" role="Docente y Contadora" location="Santiago, Chile" age={45} content="El banco de ejemplos y las evaluaciones listas son oro puro. Dejé de llevarme trabajo a casa. Lo recomiendo a todas mis colegas que sienten que el sistema educativo las está pasando por encima." imageInitials="AV" data-id="element-286" />
            <TestimonialCard name="Roberto Fernández" role="Profesor de Economía" location="Buenos Aires, Argentina" age={47} content="Trabajo con SIC 360 desde hace dos años y transformó completamente mi manera de enseñar. Los estudiantes ahora ven la contabilidad como algo útil y aplicable a su vida diaria, no como teoría abstracta." imageInitials="RF" data-id="element-287" />
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-16 bg-white" data-id="element-288">
        <div className="container mx-auto px-4 max-w-3xl" data-id="element-289">
          <div className="text-center mb-12" data-id="element-290">
            <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-291">
              Resolvé aquí tus DUDAS
            </h2>
            <p className="text-gray-600" data-id="element-292">
              Las preguntas más frecuentes sobre el pack
            </p>
          </div>

          <div className="space-y-2" data-id="element-293">
            <FAQItem question="¿Qué recibo al comprar SIC 360?" answer="Recibís el sistema completo de clases anuales de Sistemas de Información Contable, más 4 bonos exclusivos: Clases Salvavidas (Plan B Docente), Evaluaciones Listas con Rúbricas, Mapa Anual de Contenidos, y Banco de Ejemplos Explicados. Todo en formato digital para descargar inmediatamente." data-id="element-294" />
            <FAQItem question="¿Cuándo me llega?" answer="El acceso es inmediato. Una vez confirmado el pago, recibís un email con las instrucciones para descargar todo el material. Podés empezar a usarlo en menos de 5 minutos." data-id="element-295" />
            <FAQItem question="¿Cómo lo recibo?" answer="Todo el material es digital. Después de la compra, te enviamos un link de descarga a tu email. Podés guardar los archivos en tu computadora, tablet o celular, y acceder cuando quieras sin necesidad de internet." data-id="element-296" />
            <FAQItem question="¿Es físico o digital?" answer="Es 100% digital. No hay envíos físicos. Esto te permite acceder al instante y llevarlo siempre con vos en cualquier dispositivo. Además, podés imprimirlo si preferís trabajar en papel." data-id="element-297" />
            <FAQItem question="¿Necesito ser profesional?" answer="No necesitás ser contador ni tener título universitario. SIC 360 está diseñado para docentes de nivel secundario que dictan materias relacionadas con contabilidad, economía o administración. Si das clases de SIC, esto es para vos." data-id="element-298" />
            <FAQItem question="¿Tengo acceso para siempre?" answer="Sí, el acceso es vitalicio. Una vez que descargás el material, es tuyo para siempre. No hay vencimientos, renovaciones ni pagos mensuales. Comprás una vez y lo usás todos los años que quieras." data-id="element-299" />
            <FAQItem question="¿Qué hago si no me llega el acceso?" answer="Si no recibís el email en los próximos 10 minutos, revisá tu carpeta de spam. Si aún así no lo encontrás, escribinos a soporte y te lo reenviamos de inmediato. Siempre respondemos en menos de 24 horas." data-id="element-300" />
            <FAQItem question="¿Es una compra segura?" answer="Totalmente segura. Usamos la plataforma de pago más confiable de Argentina, con encriptación SSL. Aceptamos todas las tarjetas de credito y debito. Además, tenés garantía de devolución de 7 días sin preguntas." data-id="element-301" />
          </div>

          <div className="mt-12 text-center" data-id="element-302">
            <button onClick={scrollToPurchase} className="inline-flex items-center justify-center rounded-full bg-blue-900 px-8 py-4 text-lg font-bold text-white shadow-lg transition-all hover:bg-blue-800 hover:scale-105" data-id="element-303">
              EMPEZAR AHORA
            </button>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12 border-t border-gray-800" data-id="element-304">
        <div className="container mx-auto px-4 text-center" data-id="element-305">
          <h2 className="text-2xl font-bold mb-4" data-id="element-306">
            SIC <span className="text-orange-500" data-id="element-307">360</span>
          </h2>
          <p className="text-gray-400 mb-8" data-id="element-308">
            © 2026 Todos los derechos reservados.
          </p>
          <p className="text-gray-500 text-sm" data-id="element-309">
            Hecho con ❤️ para la docencia secundaria
          </p>
        </div>
      </footer>
    </div>;
}